import type { RouterProps } from 'contracts/Router';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { BASE_RESTRICTED_PRODUCTS_PATH, RESTRICTED_PRODUCTS_ROUTES } from 'lib/routes';
import { ListRestrictionEventsPage, ImportFilesPage } from 'pages/restricted-products';

export const restrictedProductsRoutes = ({
                                           location,
                                           hasPermissionTo,
                                         }: RouterProps): RouteObject => {
  const Fallback = <Navigate to={'/'} state={{ from: location }} />;

  return {
    path: BASE_RESTRICTED_PRODUCTS_PATH,
    element: hasPermissionTo(RESTRICTED_PRODUCTS_ROUTES.list().permissions)
      ? <Outlet /> : Fallback,
    children: [
      {
        path: RESTRICTED_PRODUCTS_ROUTES.list().path,
        element: <ListRestrictionEventsPage />,
      },
      {
        path: RESTRICTED_PRODUCTS_ROUTES.importFiles().path,
        element: <ImportFilesPage />,
      },
    ],
  };
};